import React, { Component } from 'react';

if (process.env.NODE_ENV !== 'test') {
  require('./Footer.scss');
}

/* eslint max-len: [0] */
export default class Footer extends Component {
  static displayName = 'Footer';

  render() {
    return (
      <footer>
        <div className="container disclaimer">
          <div className="centered">
            <div>&copy; Svenska Handelsbanken AB (publ)</div>
            <div>
              Løsningen er levert av{' '}
              <a href="//www.infrontfinance.com">Infront</a>. Kurser er levert
              av<a href="//www.oslobors.no"> Oslo Børs</a>,
              <a href="//www.vps.no"> VPS</a>,
              <a href="//www.infrontfinance.com"> Infront</a> og
              <a href="//www.interactivedata-rts.com/"> Interactive Data</a>.
              Kurser fra<a href="//www.oslobors.no"> Oslo Børs</a> er i realtid,
              andre kurser er forsinket med 15 min. eller mer.
              Estimater/nøkkeltall er levert av
              <a href="//www.factset.com"> Factset</a>.{' '}
              <a href="//www.handelsbanken.no/shb/inet/icentno.nsf/default/qB4F9931140843CBDC125745E0064ACE1">
                {' '}
                Disclaimer
              </a>{' '}
              vedr. våre analyser. Alle immaterielle rettigheter relatert til
              utenlandske indekser eies av leverandørene av denne informasjonen
              (
              <a href="//www.djindexes.com/mdsidx/downloads/crc/DJ_Indexes_Terms_Conditions.pdf">
                Dow Jones
              </a>
              , Nasdaq, CME, Deutsche Börse AG) og er beskyttet av åndsverkloven
              i det landet leverandøren har sitt hovedsete. Informasjon
              formidlet i denne tjenesten kan kun benyttes for eget bruk. Det
              tas forbehold om eventuelle feil eller mangler i data.
            </div>
            <div>Nikkei 225 &copy;Nikkei Inc.</div>
          </div>
        </div>
      </footer>
    );
  }
}
